import { render, staticRenderFns } from "./payOrderStatus.vue?vue&type=template&id=fc384824&scoped=true&"
import script from "./payOrderStatus.vue?vue&type=script&lang=js&"
export * from "./payOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./payOrderStatus.vue?vue&type=style&index=0&id=fc384824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc384824",
  null
  
)

export default component.exports